import {Injectable} from "@angular/core";


import {CoreHttpClientApiBaseService} from "@core/services/http-client-api-base/core-http-client-api-base.service";
import {ILocalPagination} from "@shared/interfaces/pagination.interface";
import {
  CreatedSolutionItemDto,
  FilterDto,
  NoteTopic,
  Orders,
  SolutionItemDto,
  SolutionItemGenericDto
} from "@server-models";
import {ILocalPageOutputDto} from "@shared/interfaces/orga-response.interface";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SharedSolutionApiService extends CoreHttpClientApiBaseService {

  loadSolution(
    missionId: number,
    paging: ILocalPagination,
    filters: FilterDto[] = [],
    noteTopic?: NoteTopic
  ): Observable<ILocalPageOutputDto<SolutionItemGenericDto[]>> {
    return super.post<ILocalPageOutputDto<SolutionItemGenericDto[]>>(
      `/tech/mission/${ missionId }/solution/item/filter`,
      undefined,
      filters,
      {
        params: {
          ...paging,
          sortField: 'createdAt',
          sort: Orders.Descending,
          ...(noteTopic !== undefined ? { noteTopic: noteTopic.toString() } : {})
        }
      }
    )
  }

  postSolutionItem(body: SolutionItemDto): Observable<CreatedSolutionItemDto> {
    return super.post<CreatedSolutionItemDto>(`/tech/solution/${ body.solutionId }/item/generic`, undefined, body)
  }
}
